var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center",style:(("background:" + (_vm.$vars.base)))},[_c('Container',[_c('Footer-Top',{staticClass:"py-6",attrs:{"data":_vm.Footer.dataTop}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }